import { useContext } from 'react'
import ConsentContext from './ConsentProvider'

const useConsent = () => {
    return useContext(ConsentContext)
}
export default useConsent